/*
  Pre-order labels for the Safir buy box (sections/sg-buy.liquid).

  Pre-order products (snippets/safir-drop.liquid: every product while the
  whole site is on pre-order, else those tagged "pre-order") show "Pre-Order"
  on the add to cart button, the status pill above the title, the pre-order
  ship line in place of "Ships in ...", and send a "Pre-order" line item
  property. The first paint comes from Liquid; assets/safir-g.js then moves
  the buy box between flavors without a page load, so this watches the
  form's product id and swaps all of it (and the sticky buy bar's label,
  from assets/sr-pdp.js) to match.

  Plain script, no imports, loaded with defer.
*/
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('script[data-sg-data]');
    var form = root.querySelector('product-form-component');
    if (!dataEl || !form) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var text = data.text || {};
    var byId = {};
    (data.products || []).forEach(function (p) {
      byId[String(p.id)] = p;
    });

    var label = root.querySelector('product-form-component button[name="add"] .add-to-cart-text__content span span');
    var ship = root.querySelector('[data-sg-ship]');
    var shipText = ship ? ship.querySelector('[data-sg-ship-text]') : null;
    var status = root.querySelector('[data-sd-status]');
    var statusLabel = status ? status.querySelector('[data-sd-status-label]') : null;
    var statusText = status ? status.querySelector('[data-sd-status-text]') : null;
    var prop = root.querySelector('[data-sd-prop]');

    function sync() {
      var product = byId[String(form.dataset.productId || data.start.productId)];
      if (!product) return;
      var po = !!product.preorder;

      var buttonText = po ? text.preorderButton : text.button;
      if (label && buttonText && label.textContent !== buttonText) label.textContent = buttonText;

      var barLabel = document.querySelector('.sr-buybar__label');
      if (barLabel && buttonText && barLabel.textContent !== buttonText) barLabel.textContent = buttonText;

      var line = po ? text.preorderShip : ship ? ship.getAttribute('data-sg-ship') : '';
      if (shipText && line && shipText.textContent !== line) shipText.textContent = line;

      if (prop) prop.disabled = !po;

      if (status) {
        var sold = po && !!product.soldout;
        status.hidden = !po;
        status.dataset.state = sold ? 'soldout' : po ? 'preorder' : 'none';
        var short = text.preorderShort || '';
        if (statusLabel) statusLabel.textContent = sold ? 'Sold out' : 'Pre-order open';
        if (statusText) statusText.textContent = sold ? 'Restock on pre-order · ' + short.toLowerCase() : short;
      }
    }

    new MutationObserver(sync).observe(form, { attributes: true, attributeFilter: ['data-product-id'] });
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-sg-buy]').forEach(function (root) {
      if (root.dataset.sgPreorder) return;
      root.dataset.sgPreorder = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: sections re-render in place. */
  document.addEventListener('shopify:section:load', boot);
})();
